import { uploadFilesGetLinks, uploadSingleFile } from "../files";
import { API, authClient } from "../index";

// Get all imagenes/archivos
export const getImagenes = (params = {}) => {
  const queryParams = new URLSearchParams({ getDisabled: "true", ...params });
  return authClient().get(`${API}/imagen?${queryParams.toString()}`);
};

// Get imagen by id
export const getImagenById = (id) => {
  return authClient().get(`${API}/imagen/${id}`);
};

// Delete imagen
export const deleteImagen = (id) => {
  return authClient().delete(`${API}/imagen/${id}`);
};

// Create imagen/archivo
export const postImagen = async (imagen, selectedFile) => {
  if (selectedFile) {
    // Determinar carpeta según tipo
    const folder = imagen.tipo === 'archivo' ? 'archivos' : 'imagenes';
    const response = await uploadSingleFile(selectedFile, folder);
    imagen.url = response?.data?.fileURL;
    
    // Detectar tipo automáticamente si no está especificado
    if (!imagen.tipo) {
      const fileName = selectedFile.name.toLowerCase();
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico'];
      imagen.tipo = imageExtensions.some(ext => fileName.endsWith(ext)) ? 'imagen' : 'archivo';
      
      if (imagen.tipo === 'archivo') {
        const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
        if (extension && extension.length <= 10) {
          imagen.tipoArchivo = extension;
        }
      }
    }
  }
  return authClient().post(`${API}/imagen`, imagen);
};

// Update imagen/archivo
export const updateImagen = async (id, imagen, selectedFile) => {
  if (selectedFile) {
    // Determinar carpeta según tipo
    const folder = imagen.tipo === 'archivo' ? 'archivos' : 'imagenes';
    const response = await uploadSingleFile(selectedFile, folder);
    imagen.url = response?.data?.fileURL;
    
    // Detectar tipo automáticamente si no está especificado
    if (!imagen.tipo) {
      const fileName = selectedFile.name.toLowerCase();
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico'];
      imagen.tipo = imageExtensions.some(ext => fileName.endsWith(ext)) ? 'imagen' : 'archivo';
      
      if (imagen.tipo === 'archivo') {
        const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
        if (extension && extension.length <= 10) {
          imagen.tipoArchivo = extension;
        }
      }
    }
  }
  return authClient().put(`${API}/imagen/${id}`, imagen);
};

// Get image usage
export const getImageUsage = (id) => {
  return authClient().get(`${API}/imagen/${id}/usage`);
};

// Get tags
export const getImageTags = () => {
  return authClient().get(`${API}/imagen/tags/list`);
};
